const initialState = {
  pending: false,
  message: null,
};

const File = (state = initialState, action) => {
  switch (action.type) {
    case 'FILE_UPLOAD_START':
      return {
        ...state,
        message: false,
        pending: true,
      };

    case 'FILE_UPLOAD_FAILURE':
      return {
        ...state,
        message: action.message || null,
        pending: false,
      };

    case 'FILE_UPLOAD_SUCCESS':
      return {
        ...state,
        pending: false,
      };

    default:
      return state;
  }
};

export default File;
